// extracted by mini-css-extract-plugin
export default {"component":"graphic_component__ZIqhb","defaultBGColor":"graphic_defaultBGColor__YRKZn"};